const cityclimateIndex = () => {
    const collapseText = () => {
        const amountOfSections = document.querySelectorAll("div[id*='collapseHeader']").length

        for (let i = 0; i < amountOfSections; i++) {
            handleCollapsedText(`collapseHeader${i}`, `collapseContent${i}`, `arrow${i}`, false)
        }
    }

    const navigationMap = () => {
        const loadMap = () => { mb.loadMapboxGlJs().done(initMap) }
        
        const initMap = () => {
            // let map : mapboxgl.Map
            let map = null
            let bounds = [5.8, 45.7, 10.5, 47.9] as [number, number, number, number]
            let latlon = new mapboxgl.LngLat(8, 46)
            let mapOptions = {
                container: 'map',
                center: latlon,
                style: `https://maptiles.meteoblue.com/styles/terrain-en/style.json`,
                zoom: 6,
                maxBounds: bounds,
            }
            const cities = [
                {name: 'zurich', country: 'switzerland', lat: 47.3769, lon: 8.5417},
                {name: 'basel', country: 'switzerland', lat: 47.5596, lon: 7.5886},
            ]

            map = new mapboxgl.Map(mapOptions)

            map.dragRotate.disable();
            map.touchZoomRotate.disableRotation();

            map.addControl(new mapboxgl.NavigationControl({showCompass: false}))

            for (const city of cities) {
                const el = document.createElement('div')
                el.className = 'cityMarkerAnchor'
                el.innerHTML = '<div class="cityMarker"></div>'
                
                el.addEventListener('click', () => {
                    window.location.href = `/${window.mb.settings.lang}/products/cityclimate/${city.name}`
                })
                
                new mapboxgl.Marker(el)
                    .setLngLat({lng: city.lon, lat: city.lat})
                    .addTo(map)
            }
        }

        return {
            loadMap: loadMap,
        }
    }

    return {
        navigationMap: navigationMap,
        collapseText: collapseText,
    }
}

window.addEventListener('load', function loadCityclimate() {
    window.removeEventListener('load', loadCityclimate, false)

    const c = cityclimateIndex()

    try {
        c.navigationMap().loadMap()
        c.collapseText()

    } catch(e) {
        if(window.console) {
            console.warn(e)
        }
    }

    window.addEventListener('resize', function resize() {
        // c.climateChange()
    })
}, false)

const handleCollapsedText = (headerId, textId, arrowId, open) => {
    const header = document.getElementById(headerId)
    const text = document.getElementById(textId)
    const arrow = document.getElementById(arrowId)

    if (open) {
        text.style.height = 'auto'
        arrow.style.transform = 'rotate(270deg)'
        text.addEventListener('click', (e) => {
            text.style.height = '0px'
            arrow.style.transform = 'rotate(90deg)'
        })
    } else {
        text.style.height = '0px'
    }

    header.addEventListener('click', (e) => {
        if (text.style.height === '0px') {
            text.style.height = 'auto'
            arrow.style.transform = 'rotate(270deg)'
            text.addEventListener('click', (e) => {
                text.style.height = '0px'
                arrow.style.transform = 'rotate(90deg)'
            })
        } else {
            text.style.height = '0px'
            arrow.style.transform = 'rotate(90deg)'
        }
    })
}

export default cityclimateIndex